/* 3DOrder conversion v7, 2026-09-18. No price, discount or checkout writes. */
(() => {
  if (window.__doConversionV7) return;
  window.__doConversionV7 = true;
  let queued = false;
  let cartState = null;
  let destination = null;
  let refreshTimer;
  let requestVersion = 0;
  let controller;

  function mountPurchaseOptions() {
    document.querySelectorAll('template[data-do-v7-after-purchase]').forEach((template) => {
      if (template.closest('dialog, product-card, .quick-add-modal')) return;
      const buttons = template.closest('.product-form-buttons');
      if (!buttons) return;
      const anchor = buttons.querySelector('.do-cart-reassurance');
      if (!anchor) return;
      anchor.after(template.content.cloneNode(true));
      template.remove();
    });
  }
  function scheduleMount() {
    if (queued) return;
    queued = true;
    queueMicrotask(() => { queued = false; mountPurchaseOptions(); });
  }
  function snapshot(cart) {
    if (!cart || !Array.isArray(cart.items) || !Number.isFinite(Number(cart.total_price))) return null;
    return { total: Math.max(0, Number(cart.total_price)), currency: cart.currency,
      physical: cart.items.some((item) => item.requires_shipping === true) };
  }
  function updateProgress() {
    document.querySelectorAll('do-cart-progress').forEach((widget) => widget.refresh());
  }
  function refreshCart(event) {
    clearTimeout(refreshTimer);
    controller?.abort();
    const version = ++requestVersion;
    const incoming = snapshot(event?.detail?.resource);
    if (incoming) { cartState = incoming; updateProgress(); return; }
    document.querySelectorAll('do-cart-progress').forEach((widget) => { widget.hidden = true; });
    refreshTimer = setTimeout(async () => {
      controller = new AbortController();
      try {
        const root = window.Shopify?.routes?.root || '/';
        const response = await fetch(`${root}cart.js`, { credentials: 'same-origin', cache: 'no-store', signal: controller.signal });
        if (!response.ok) throw new Error('Cart read failed');
        const state = snapshot(await response.json());
        if (version !== requestVersion) return;
        if (!state) throw new Error('Invalid cart response');
        cartState = state;
        updateProgress();
      } catch (error) {
        if (error.name !== 'AbortError' && version === requestVersion) {
          document.querySelectorAll('do-cart-progress').forEach((widget) => { widget.hidden = true; });
        }
      }
    }, 120);
  }
  if (!customElements.get('do-cart-progress')) {
    customElements.define('do-cart-progress', class extends HTMLElement {
      connectedCallback() {
        try { this.thresholds = JSON.parse(this.dataset.thresholds || '{}'); }
        catch { this.thresholds = {}; }
        this.initial = { total: Number(this.dataset.total), currency: this.dataset.currency,
          physical: this.dataset.physical === 'true' };
        this.refresh();
      }
      refresh() {
        const state = cartState || this.initial;
        if (!state) return;
        const country = destination?.code || this.dataset.country;
        const label = destination?.name || this.dataset.countryName || country;
        const threshold = state.currency === 'EUR' ? Number(this.thresholds?.[country] || 0) : 0;
        this.hidden = !state.physical || !threshold || !Number.isFinite(state.total);
        if (this.hidden) return;
        const remaining = Math.max(0, threshold - state.total);
        const en = (this.dataset.locale || 'de').startsWith('en');
        const formatter = new Intl.NumberFormat(this.dataset.locale || 'de-AT', { style: 'currency', currency: state.currency });
        const text = this.querySelector('[data-progress-label]');
        const progress = this.querySelector('progress');
        const target = this.querySelector('[data-progress-country]');
        if (text) text.textContent = remaining > 0
          ? (en ? `${formatter.format(remaining / 100)} away from free standard shipping.` : `Noch ${formatter.format(remaining / 100)} bis zum kostenlosen Standardversand.`)
          : (en ? 'Free standard shipping threshold reached.' : 'Gratisversandgrenze für Standardversand erreicht.');
        if (target) target.textContent = en ? `Delivery to ${label}` : `Lieferung nach ${label}`;
        if (progress) { progress.max = threshold; progress.value = Math.min(state.total, threshold); progress.setAttribute('aria-label', text?.textContent || ''); }
      }
    });
  }
  function boot() {
    mountPurchaseOptions();
    const observer = new MutationObserver((records) => {
      if (records.some((record) => [...record.addedNodes].some((node) => node.nodeType === 1 &&
        (node.matches('template[data-do-v7-after-purchase]') || node.querySelector('template[data-do-v7-after-purchase]'))))) scheduleMount();
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }
  document.addEventListener('variant:update', scheduleMount);
  document.addEventListener('shopify:section:load', scheduleMount);
  document.addEventListener('cart:update', refreshCart);
  document.addEventListener('discount:update', refreshCart);
  document.addEventListener('change', (event) => {
    if (!event.target.matches?.('[data-shipping-country]')) return;
    destination = { code: event.target.value, name: event.target.selectedOptions[0]?.textContent.trim() || event.target.value };
    updateProgress();
  });
  window.addEventListener('pageshow', (event) => { if (event.persisted) refreshCart(); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
})();
